import { useEffect, useRef } from 'react';
import { TasksTable } from '@/features/tasks';
import {
  Panel,
  PanelHeader,
  PanelTitle,
  PanelDescription,
  Link,
  PanelSection,
} from '@customerio/pluma-components/react';
import { useActiveHealthTab, useScrollTo } from '../hooks';

export function TasksPanel() {
  const { activeTab } = useActiveHealthTab();
  const { scrollTo, setScrollTo } = useScrollTo();
  const panelRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (scrollTo === 'tasks' && activeTab === 'data') {
      panelRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      void setScrollTo(null);
    }
  }, [scrollTo, activeTab, setScrollTo]);

  return (
    <Panel ref={panelRef} id="tasks">
      <PanelHeader>
        <PanelTitle>Tasks</PanelTitle>
        <PanelDescription>
          Monitor background tasks, like segment creation and imports, across your workspace.{' '}
          <Link href="https://docs.customer.io/accounts-and-workspaces/workspace-tasks/" isExternal variant="secondary">
            Learn more
          </Link>
        </PanelDescription>
      </PanelHeader>
      <PanelSection withPadding={false}>
        <TasksTable isWorkspaceHealthView={true} isDataTabActive={activeTab === 'data'} />
      </PanelSection>
    </Panel>
  );
}
